<section class="aza-section aza-theme pager-container">
    <div class="aza-section-content profile-event aza-horizontal-stack aza-vertical-items-centered">
        <span>{{rangeText}}</span>
        <button [disabled]="!canMoveToPrev" (click)="goPrev()" class="pager-prev-button">&lt;</button>
        <button [disabled]="!canMoveToNext" (click)="goNext()" class="pager-next-button">&gt;</button>
    </div>
</section>
